export default __webpack_public_path__ + "static/media/Rectangle59.2e130159.png";